import { DatesContainer } from '../../containers/filters/DatesContainer';
import { EFilterType, IFilter } from '../../types/filters';

export const COOKIE_NAME = 'skipDatesModal';

export const dates: IFilter = {
  component: DatesContainer,
  type: EFilterType.Openable,
};
